import { apiClient } from './client';

export type ExportType =
  | 'expenses'
  | 'timeline'
  | 'checklist'
  | 'guests'
  | 'kibuddim'
  | 'floor-plan'
  | 'seating-chart';
export type ExportFormat = 'pdf' | 'csv';
export type SeatingChartOrder = 'table' | 'name';

export interface SeatingChartExportParams {
  format?: ExportFormat;
  orderBy?: SeatingChartOrder;
  /** Multi-select filters that mirror the guest-list filter bar. */
  side?: string[];
  rsvpStatus?: string[];
  familyGroup?: string[];
}

/**
 * Download a seating chart export. axios serializes array params as
 * `?side=a&side=b`, which the backend's qs parser collapses to
 * `req.query.side = ['a', 'b']`.
 */
export async function downloadSeatingChart(
  eventId: string,
  options: SeatingChartExportParams = {},
): Promise<Blob> {
  const params: Record<string, string | string[]> = {};
  if (options.format === 'csv') params.format = 'csv';
  if (options.orderBy === 'name') params.orderBy = 'name';
  if (options.side?.length) params.side = options.side;
  if (options.rsvpStatus?.length) params.rsvpStatus = options.rsvpStatus;
  if (options.familyGroup?.length) params.familyGroup = options.familyGroup;
  const { data } = await apiClient.get(`/export/events/${eventId}/seating-chart`, {
    params,
    responseType: 'blob',
  });
  return data;
}

export async function downloadExport(
  eventId: string,
  type: ExportType,
  format: ExportFormat = 'pdf',
): Promise<Blob> {
  const params: Record<string, string> = {};
  if (format === 'csv') params.format = 'csv';

  const { data } = await apiClient.get(`/export/events/${eventId}/${type}`, {
    params,
    responseType: 'blob',
  });
  return data;
}

export function triggerDownload(blob: Blob, filename: string): void {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}
